export const FOOTER_BLOCK_s7 = {
  "blockType": "FOOTER",
  "blockDesign": "FooterDesign2",
  "editFormName": "FOOTER_FORM_2",
  "styleProps": {
    "background-color": "#ffffff",
    "padding": "50px 50px 50px 50px"
  },
  "metaDataId": 1746354819544,
  "company": {
    "description": {
      "list": [
        "Navdic 2023. All rights reserved."
      ]
    },
    "name": {
      "text": "꩜ Navdic",
      "styleProps": {
        "color": "#333333",
        "font-size": "3.75rem",
        "line-height": "1",
        "margin": "0px 0px 20px 0px",
        "font-weight": "700"
      }
    },
    "copy": {
      "text": "Transforming Businesses with Innovative Software Solutions",
      "styleProps": {
        "margin": "120px 0px 60px 0px",
        "color": "#333333",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "font-weight": "500"
      },
      "stylePropsTab": {
        "margin": "80px 0px 120px 0px"
      },
      "stylePropsMob": {
        "margin": "60px 0px 60px 0px"
      }
    },
    "styleProps": {
      "width": "100%",
      "background-color": "",
      "padding": "20px 20px 20px 20px",
      "color": "#808080"
    },
    "logo": {
      "text": ""
    }
  },
  "column1": {
    "links": [
      {
        "label": {
          "text": "About",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#333333"
          },
          "stylePropsTab": {
            "font-size": "1.5rem",
            "line-height": "2rem"
          }
        },
        "url": "#about"
      },
      {
        "label": {
          "text": "Products",
          "styleProps": {
            "color": "#333333"
          }
        },
        "url": "#products"
      },
      {
        "label": {
          "text": "Services",
          "styleProps": {
            "color": "#333333"
          }
        },
        "url": "fasty"
      }
    ],
    "title": {
      "text": "Company",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 20px 0px",
        "color": "#333333",
        "font-weight": "600"
      }
    },
    "styleProps": {
      "width": "none",
      "color": "",
      "background-color": "",
      "border-radius": "0px",
      "padding": "20px 20px 20px 20px"
    }
  },
  "column2": {
    "links": [
      {
        "label": {
          "text": "hello@promosite.com",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#333333"
          }
        },
        "url": "fasty"
      },
      {
        "label": {
          "text": "careers@promosite.com",
          "styleProps": {
            "color": "#333333"
          }
        },
        "url": "fasty"
      }
    ],
    "title": {
      "text": "Get in touch",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 20px 0px",
        "color": "#333333",
        "font-weight": "600"
      }
    },
    "styleProps": {
      "background-color": "",
      "width": "100%",
      "padding": "20px 20px 20px 20px"
    }
  },
  "column4": {
    "title": {
      "text": "Connect",
      "styleProps": {
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "0px 0px 20px 0px",
        "color": "#333333",
        "font-weight": "600"
      }
    },
    "links": [
      {
        "label": {
          "text": "Facebook",
          "styleProps": {
            "padding": "0px 0px 0px 0px",
            "margin": "0px 0px 0px 0px",
            "color": "#333333"
          }
        },
        "url": "http://facebook.com/promosite",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1681109394227/1746351929555.png",
          "styleProps": {
            "padding": "0px 0px 0px 0px",
            "margin": "0px 10px 0px 0px"
          }
        }
      },
      {
        "label": {
          "text": "Twitter"
        },
        "url": "http://twitter.com/promosite",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1681109394227/1746351953955.png",
          "styleProps": {
            "margin": "0px 10px 0px 0px"
          }
        }
      },
      {
        "label": {
          "text": "Pinterest",
          "styleProps": {
            "padding": "0px 0px 0px 0px"
          }
        },
        "url": "",
        "image": {
          "text": "https://d11lx8wl9i3fvs.cloudfront.net/1681109394227/1746351967712.png"
        }
      }
    ],
    "styleProps": {
      "background-color": "",
      "padding": "20px 20px 20px 20px"
    },
    "type": "only_icon"
  },
  "bottom_links": {
    "links": [
      {
        "label": {
          "text": "Terms & Conditions",
          "styleProps": {
            "font-size": "1rem",
            "line-height": "1.5rem",
            "color": "#808080"
          }
        },
        "url": ""
      },
      {
        "label": {
          "text": "Privacy Policy",
          "styleProps": {
            "color": "#808080"
          }
        },
        "url": ""
      },
      {
        "label": {
          "text": "Disclaimer",
          "styleProps": {
            "color": "#808080"
          }
        },
        "url": ""
      }
    ],
    "styleProps": {
      "padding": "50px 0px 50px 0px",
      "background-color": "",
      "font-size": "1rem",
      "line-height": "1.5rem",
      "color": "#808080",
      "margin": "120px 0px 0px 0px"
    },
    "title": {
      "styleProps": {
        "color": "#cccccc"
      }
    }
  },
  "afterIndex": 27,
  "blockId": 1746354819544
}